/**
 * Provenance of a booking line; every event has a FIXED account/direction semantic (02-datenmodell.md
 * §2.3). Events 0-5 are the engine's reconcile events (mandatory K-13 mapping); PAYOUT(6) is resolved
 * via ProvisionType.payoutTransactionType; MANUAL_ADJUSTMENT(7)/RESERVE_TRANSFER(8) are provenance
 * values of manual bookings and never count towards the engine's reconcile actual.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionTransactionEvent}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionTransactionEvent {

    PROVISION_BOOKING,
    PROVISION_BOOKING_REVERSAL,
    RESERVE_BOOKING,
    RESERVE_BOOKING_REVERSAL,
    CANCELLATION_CHARGE,
    CANCELLATION_CHARGE_REVERSAL,
    PAYOUT,
    MANUAL_ADJUSTMENT,
    RESERVE_TRANSFER
}
